import { Button, ButtonProps, Menu, Stack } from '@mantine/core';
import { useToggle } from '@mantine/hooks';
import { ChevronDown } from 'lucide-react';
import { useActiveRouteGroup } from 'shared/lib';
import { router } from 'shared/routing';
import cls from './nav-menu.module.scss';

export type NavMenuProps = {
	label: string;
} & Omit<ButtonProps, 'rightSection' | 'onClick'>;

export const NavMenu = ({ label, classNames, children, ...props }: NavMenuProps) => {
	const [opened, toggle] = useToggle();

	const active = useActiveRouteGroup(children, router);

	return (
		<Menu
			data-active={active || undefined}
			opened={opened}
			offset={10}
			position='bottom-start'
			onClose={() => toggle(false)}
		>
			<Menu.Target>
				<Button
					variant='ghost'
					rightSection={<ChevronDown className={cls.navMenuArrow} />}
					classNames={{
						root: cls.navMenuTarget,
					}}
					onClick={() => toggle()}
					{...props}
				>
					{label}
				</Button>
			</Menu.Target>
			<Menu.Dropdown>
				<Stack className={cls.navMenuStack}>{children}</Stack>
			</Menu.Dropdown>
		</Menu>
	);
};
